import {openResourceModal} from '../../core/modalCommand';
import {
	CAPTIVE_PORTAL_CREATE_MODAL_EVENT,
	CAPTIVE_PORTAL_DELETE_MODAL_EVENT,
	CAPTIVE_PORTAL_EDIT_MODAL_EVENT,
	CAPTIVE_PORTAL_VOUCHER_MODAL_EVENT,
} from './events';

/**
 * Open the Add Captive Portal form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openCaptivePortalCreateModal(command, envelope) {
	return openResourceModal(CAPTIVE_PORTAL_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open a captive portal's Edit form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openCaptivePortalEditModal(command, envelope) {
	return openResourceModal(CAPTIVE_PORTAL_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open a captive portal's Delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openCaptivePortalDeleteModal(command, envelope) {
	return openResourceModal(CAPTIVE_PORTAL_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open a captive portal's Generate Voucher form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openCaptivePortalVoucherModal(command, envelope) {
	return openResourceModal(CAPTIVE_PORTAL_VOUCHER_MODAL_EVENT, command, envelope);
}
